// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__10HUl","header":"Messages_header__tIUHb"};